"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFilterQuickSelect = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Divider_1 = tslib_1.__importDefault(require("@mui/material/Divider"));
const SelectableChipGroup_1 = tslib_1.__importDefault(require("./SelectableChipGroup"));
const DateTimeFilterQuickSelect = (props) => {
    const { onSelect, optionGroups, label, ...rest } = (0, material_1.useThemeProps)({ props, name: "DateTimeFilterQuickSelect" });
    return (react_1.default.createElement(Box_1.default, { ...rest },
        react_1.default.createElement(material_1.Typography, { variant: "subtitle2" }, label),
        optionGroups?.map((option, idx) => {
            const isLastGroup = optionGroups?.length - 1 === idx;
            return (react_1.default.createElement(Box_1.default, { key: idx, mt: 2 },
                react_1.default.createElement(SelectableChipGroup_1.default, { onSelect: onSelect, ...option }),
                !isLastGroup && react_1.default.createElement(Divider_1.default, { sx: { my: 2, mx: -1.5 } })));
        })));
};
exports.DateTimeFilterQuickSelect = DateTimeFilterQuickSelect;
exports.default = exports.DateTimeFilterQuickSelect;
